import { render, staticRenderFns } from "./info-menu.vue?vue&type=template&id=477cbb5e&"
import script from "./info-menu.vue?vue&type=script&lang=js&"
export * from "./info-menu.vue?vue&type=script&lang=js&"
import style0 from "./info-menu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('477cbb5e')) {
      api.createRecord('477cbb5e', component.options)
    } else {
      api.reload('477cbb5e', component.options)
    }
    module.hot.accept("./info-menu.vue?vue&type=template&id=477cbb5e&", function () {
      api.rerender('477cbb5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/info-menu/info-menu.vue"
export default component.exports